// extracted by mini-css-extract-plugin
export default {"declinedButtonContainer":"styles_declinedButtonContainer__nwaQO","declineButton":"styles_declineButton__BeNo5","svgMessage":"styles_svgMessage__RBWki"};